import React, { useRef, useEffect, useState, useContext } from "react";
import axios from 'axios';
import './Modal.css'; // Assuming you have some basic styles for the modal
import { ReactComponent as Close } from '../../svg/close.svg';
import { Context } from "../../context";
const ip = process.env.REACT_APP_IP;

function ModalSortLvlUp({ isOpen, spell, idPerso, setOpen,token }) {
    const { fetchPersonnage } = useContext(Context);

    const [nomSort, setNomSort] = useState(spell.nom);
    const [descriptionSort, setDescriptionSort] = useState(spell.description);
    const [effetSort, setEffetSort] = useState(spell.effet);
    const [coutSort, setCoutSort] = useState(spell.cout);
    const [niveauSort, setNiveauSort] = useState(spell.niveau);
    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    if (!isOpen) return null;
    const handleSubmit = async () => {
        if (nomSort === "" || effetSort === "" || descriptionSort === "" || coutSort === "") {
            console.log("Tous les champs doivent être remplis");
        } else {
            try {
                await axios.post(`${ip}/sort`, {
                    nomSort,
                    descriptionSort,
                    effetSort,
                    coutSort,
                    idPerso,
                    niveauSort,
                    levelup: true
                },        {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    } 
                  });
                setNomSort("");
                setDescriptionSort("");
                setEffetSort("");
                setCoutSort("");
                setOpen(false); // Close the modal
                fetchPersonnage()
            } catch (error) {
                console.error('Erreur:', error);
            }
        }
    };


    return (
        <div className="modal-overlay-block" >

            <div className='modal_flex' ref={wrapperRef}>
                <div className="close" onClick={() => setOpen(false)}><Close></Close></div>
                <div className="modal_title"><span>{spell.nom}</span></div>
                <textarea
                    type="text"
                    value={descriptionSort}
                    onChange={e => setDescriptionSort(e.target.value)}
                    placeholder="Description du Sort"
                    className='modal-corp pct-90 modal_bloc input-transparent'
                />
                <input
                    type="text"
                    value={effetSort}
                    onChange={e => setEffetSort(e.target.value)}
                    placeholder="Effet du Sort"
                    className='pct-90 modal_bloc input-transparent'
                />
                <div className=" margin_right_2em">
                    <input
                        type="number"
                        value={coutSort}
                        onChange={e => setCoutSort(e.target.value)}
                        placeholder="Cout du Sort"
                        className='cout-input input-transparent'
                    />

                    <span>Energies</span>
                </div>

                <button onClick={handleSubmit} className='pct-90 button_modal modal_bloc button-large'>Enregistrer</button>
            </div>
        </div>
    );
}

export default ModalSortLvlUp;
